<template>
  <div class="quotes-container">
    <img
      v-if="quote == 1"
      src="../../../public/resources/images/quote1.jpg"
      alt="image"
      class="quote-image"
    />
    <img
      v-if="quote == 2"
      src="../../../public/resources/images/quote2.jpg"
      alt="image"
      class="quote-image"
    />
    <img
      v-if="quote == 3"
      src="../../../public/resources/images/quote3.jpg"
      alt="image"
      class="quote-image"
    />
    <img
      v-if="quote == 4"
      src="../../../public/resources/images/quote4.jpg"
      alt="image"
      class="quote-image"
    />
  </div>
</template>

<script>
export default {
  name: "quotable",
  data() {
    return {
      quote: 1
    };
  },
  mounted() {
    setInterval(() => {
      if (this.quote < 4) {
        this.quote++;
      } else {
        this.quote = 1;
      }
    }, 3000);
  },
  props: {
    tool: {
      type: Object,
      required: false,
      default: () => {}
    },
    focus: {
      type: Object,
      required: false,
      default: () => {}
    },
    user: {
      type: Object,
      required: false,
      default: () => {}
    },
    typeaheadApps: {
      type: Array,
      default: () => ["Maps", "Calculator"]
    },
    idprop: {
      type: String
    },
    showTracking: {
      type: Boolean
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.quotes-container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .quote-image {
    margin-top: 6px;
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }
}
</style>
